/**
 * Get URL parameter value
 */
export const getUrlParameter = (name) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
};

/**
 * Format timestamp
 */
export const formatTime = (date) => {
  return new Date(date).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * Format date
 */
export const formatDate = (date) => {
  return new Date(date).toLocaleDateString([], {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

/**
 * Validate email
 */
export const isValidEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

/**
 * Validate phone
 */
export const isValidPhone = (phone) => {
  const cleaned = phone.replace(/[\s\-\(\)]/g, '');
  return /^\d{10,15}$/.test(cleaned);
};

/**
 * Truncate text
 */
export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

/**
 * Check if needs contact (based on AI response)
 */
export const checkNeedsContact = (response) => {
  const keywords = [
    'property manager or owner',
    'phone number or email',
    'call or text you back',
  ];
  
  const lowerResponse = response.toLowerCase();
  return keywords.some(keyword => lowerResponse.includes(keyword));
};

/**
 * Generate session storage key
 */
export const getSessionStorageKey = (guidebookSlug) => {
  return `chatbot_session_${guidebookSlug}`;
};

/**
 * Save to session storage
 */
export const saveToSessionStorage = (key, data) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error('Failed to save to session storage:', error);
  }
};

/**
 * Load from session storage
 */
export const loadFromSessionStorage = (key) => {
  try {
    const data = sessionStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Failed to load from session storage:', error);
    return null;
  }
};

/**
 * Clear session storage
 */
export const clearSessionStorage = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.error('Failed to clear session storage:', error);
  }
};